import { useMutation, useQueryClient } from "@tanstack/react-query";
import api, { endpoints, paymentInfoQueryOptions } from "@vixi/api";
import { PaymentInfo } from "@vixi/types";
import { AxiosResponse } from "axios";

interface CancelSubscriptionResponse {
  statusCode: number;
}

export const useCancelSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["cancel-subscription"],
    mutationFn: async () => {
      const response = (await api.delete(
        endpoints.cancelSubscription,
      )) as AxiosResponse<CancelSubscriptionResponse>;

      if (response.status !== 200 || response.data.statusCode !== 200) {
        throw new Error("Failed to cancel subscription");
      }

      queryClient.setQueryData<PaymentInfo>(paymentInfoQueryOptions().queryKey, (oldData) => {
        if (!oldData) return oldData;

        const freePlan = oldData.plans.find((plan) => plan.monthlyPrice === 0)?.planType;

        return {
          ...oldData,
          plans: oldData.plans.map((plan) => {
            if (plan.planType === freePlan) {
              return {
                ...plan,
                inPlan: true,
              };
            }
            return {
              ...plan,
              inPlan: false,
            };
          }),
        };
      });

      queryClient.invalidateQueries({
        queryKey: paymentInfoQueryOptions().queryKey,
      });

      return response.data;
    },
  });
};
